import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';

export type UserListHeadCell = {
    id: string;
    label: string;
    alignRight?: boolean;
};

export type UserListHeadProps = {
    order?: 'asc' | 'desc';
    orderBy?: string;
    headLabel: UserListHeadCell[];
    rowCount?: number;
    numSelected?: number;
};

export default function UserListHead({ order, orderBy, headLabel }: UserListHeadProps) {
    return (
        <TableHead>
            <TableRow>
                { headLabel.map((headCell) => (
                    <TableCell
                        key={ headCell.id }
                        align={ headCell.alignRight ? 'right' : 'left' }
                        sortDirection={ orderBy === headCell.id ? order : false }
                    >
                        <TableSortLabel hideSortIcon>
                            { headCell.label }
                        </TableSortLabel>
                    </TableCell>
                )) }
            </TableRow>
        </TableHead>
    );
}
